module.exports = __webpack_public_path__ + "static/media/offers.63ce91a9.svg";